export default "__VITE_ASSET__BXJ8pMmF__"